'use strict';
var symbolObservable = require('symbol-observable');

module.exports = function (fn) {
	return Boolean(fn && fn[symbolObservable]);
};



//////////////////
// WEBPACK FOOTER
// ./~/is-observable/index.js
// module id = 496
// module chunks = 0